/* Ermeco Signage landingspagina: slides, scroll-animaties, prijzen met staffel en looptijd */
(function () {
  if (window.ErmecoSignage) return;
  document.documentElement.classList.add('es-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(value, currency) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency || 'EUR' }).format(value);
    } catch (e) {
      return '€ ' + value.toFixed(2).replace('.', ',');
    }
  }
  function norm(s) {
    return String(s || '').toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, '');
  }
  function parseJSON(s, fallback) {
    try { return JSON.parse(s); } catch (e) { return fallback; }
  }

  /* ---------- Slides in de hero ---------- */
  function initSlides(root) {
    root.querySelectorAll('[data-es-slides]').forEach(function (view) {
      if (view._es) return;
      view._es = true;
      var slides = view.querySelectorAll('.es-slide');
      var bar = view.querySelector('.es-screen__bar i');
      var interval = parseInt(view.getAttribute('data-es-interval'), 10) || 4000;
      view.style.setProperty('--es-interval', interval + 'ms');
      var i = 0;
      function show(n) {
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
        if (bar) { bar.classList.remove('is-running'); void bar.offsetWidth; bar.classList.add('is-running'); }
      }
      show(0);
      if (reduce || slides.length < 2) { if (bar) bar.classList.remove('is-running'); return; }
      setInterval(function () { i = (i + 1) % slides.length; show(i); }, interval);
    });
  }

  /* ---------- Scroll-animaties ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;

  function initReveal(root) {
    root.querySelectorAll('[data-es-reveal]').forEach(function (el) {
      if (!io || reduce) { el.classList.add('is-visible'); return; }
      io.observe(el);
    });
  }

  /* ---------- Prijzen ---------- */
  function initPricing(root) {
    root.querySelectorAll('[data-es-pricing]').forEach(function (sec) {
      if (sec._es) return;
      sec._es = true;

      var cur = sec.getAttribute('data-es-currency') || 'EUR';
      var tiers = parseJSON(sec.getAttribute('data-es-tiers'), []).filter(function (t) { return t && t.min > 0; });
      tiers.sort(function (a, b) { return a.min - b.min; });
      var termLabels = (sec.getAttribute('data-es-term-labels') || '').split(',').map(function (s) { return s.trim(); });
      var termMonths = (sec.getAttribute('data-es-term-months') || '').split(',').map(function (s) { return parseInt(s, 10) || 0; });
      var nudgeRange = parseInt(sec.getAttribute('data-es-nudge-range'), 10);
      if (isNaN(nudgeRange)) nudgeRange = 2;

      function tierIndex(n) {
        var idx = 0;
        tiers.forEach(function (t, i) { if (n >= t.min) idx = i; });
        return idx;
      }
      function tierLabel(i) {
        if (!tiers[i]) return '';
        return tiers[i + 1] ? tiers[i].min + '-' + (tiers[i + 1].min - 1) : tiers[i].min + '+';
      }

      /* Keuze A / B */
      var radios = sec.querySelectorAll('input[name^="es-situatie"]');
      function syncChoice() {
        radios.forEach(function (r) {
          var panel = sec.querySelector('[data-es-plan="' + r.value + '"]');
          if (panel) panel.hidden = !r.checked;
          var opt = r.closest('.es-opt');
          if (opt) opt.classList.toggle('is-checked', r.checked);
        });
      }
      radios.forEach(function (r) { r.addEventListener('change', syncChoice); });
      syncChoice();

      /* Per pakket */
      sec.querySelectorAll('[data-es-plan]').forEach(function (panel) {
        if (!tiers.length) return;
        var isComp = panel.getAttribute('data-es-kind') === 'compleet';
        var term = parseInt(panel.getAttribute('data-es-term'), 10) || 0;
        var variants = parseJSON(panel.getAttribute('data-es-variants'), []);
        var input = panel.querySelector('[data-es-qty-input]');
        var form = panel.querySelector('form');
        var modal = panel.querySelector('dialog');
        var one = function (sel) { return panel.querySelector(sel); };
        var all = function (sel, fn) { panel.querySelectorAll(sel).forEach(fn); };

        /* Staffeltabel: labels als bereik tonen */
        all('[data-es-row]', function (row) {
          var min = parseInt(row.getAttribute('data-es-row'), 10);
          var i = -1;
          tiers.forEach(function (t, k) { if (t.min === min) i = k; });
          var lab = row.querySelector('[data-es-row-label]');
          if (lab && i > -1) lab.textContent = tierLabel(i).replace('-', '–');
        });

        function termIdx() { return isComp ? term : 0; }
        function price(i, t) {
          var tier = tiers[i];
          if (!tier) return 0;
          return isComp ? (tier.c[t] || 0) : tier.basic;
        }
        function pickVariant(i) {
          if (!variants.length) return null;
          var tl = norm(tierLabel(i));
          var termNorm = norm(termLabels[termIdx()] || '');
          var match = null;
          variants.forEach(function (v) {
            var t = norm(v.t);
            if (match) return;
            if (t.indexOf(tl) > -1 && (!isComp || !termNorm || t.indexOf(termNorm) > -1)) match = v;
          });
          return match || variants[0];
        }

        function update() {
          var n = Math.max(1, Math.min(999, parseInt(input.value, 10) || 1));
          input.value = n;
          var t = termIdx();
          var i = tierIndex(n);
          var unit = price(i, t);
          var total = unit * n;

          all('[data-es-unit]', function (e) { e.textContent = money(unit, cur); });
          all('[data-es-total]', function (e) { e.textContent = money(total, cur); });
          all('[data-es-tier-label]', function (e) { e.textContent = '(' + tierLabel(i).replace('-', '–') + ' schermen)'; });

          /* Termijnknoppen in blok en pop-up gelijk houden */
          all('[data-es-term-input]', function (r) {
            r.checked = parseInt(r.value, 10) === t;
            var l = r.closest('.es-term');
            if (l) l.classList.toggle('is-checked', r.checked);
          });

          if (isComp) {
            all('[data-es-term-text]', function (e) { e.textContent = 'Prijs bij ' + (termLabels[t] || ''); });
            all('[data-es-cell]', function (cell) {
              var p = parseFloat(cell.getAttribute('data-p' + t));
              if (!isNaN(p)) cell.textContent = money(p, cur);
            });
          }

          /* Besparing t.o.v. de basisprijs (1 scherm, kortste looptijd) */
          var saving = one('[data-es-saving]');
          if (saving) {
            var diff = Math.round((price(0, 0) - unit) * n * 100) / 100;
            saving.hidden = !(diff > 0);
            if (diff > 0) {
              var why = isComp ? (t > 0 && i > 0 ? 'looptijd- en staffelkorting' : (t > 0 ? 'looptijdkorting' : 'staffelkorting')) : 'staffelkorting';
              saving.textContent = 'Je bespaart ' + money(diff, cur) + ' per maand met ' + why + '.';
            }
          }

          /* Tip: scherm(en) toevoegen tot de volgende staffel */
          var nudge = one('[data-es-nudge]');
          if (nudge) {
            var next = tiers[i + 1];
            var extra = next ? next.min - n : 0;
            if (next && nudgeRange > 0 && extra <= nudgeRange) {
              var nextUnit = price(i + 1, t);
              var diffTotal = next.min * nextUnit - total;
              var txt;
              if (diffTotal <= 0) {
                txt = 'Met ' + next.min + ' schermen betaal je ' + money(nextUnit, cur) + ' per scherm en in totaal zelfs ' + money(-diffTotal, cur) + ' per maand minder dan nu.';
              } else if (extra === 1) {
                txt = 'Nog 1 scherm erbij? Dan betaal je ' + money(nextUnit, cur) + ' per scherm voor alle ' + next.min + ' schermen. Dat extra scherm kost je dan maar ' + money(diffTotal, cur) + ' per maand.';
              } else {
                txt = 'Nog ' + extra + ' schermen erbij? Dan betaal je ' + money(nextUnit, cur) + ' per scherm voor alle ' + next.min + ' schermen. Die ' + extra + ' extra schermen kosten je samen maar ' + money(diffTotal, cur) + ' per maand.';
              }
              one('[data-es-nudge-text]').textContent = txt;
              var btn = one('[data-es-nudge-add]');
              btn.textContent = '+ ' + extra + (extra === 1 ? ' scherm toevoegen' : ' schermen toevoegen');
              btn.onclick = function () { input.value = next.min; update(); };
              nudge.hidden = false;
            } else {
              nudge.hidden = true;
            }
          }

          /* Huidige staffel markeren */
          all('[data-es-row]', function (row) {
            row.classList.toggle('is-current', parseInt(row.getAttribute('data-es-row'), 10) === tiers[i].min);
          });

          /* Samenvatting in het pakketblok en knopteksten */
          var summary = one('[data-es-summary]');
          if (summary) {
            summary.hidden = n < 2;
            if (n > 1) summary.textContent = 'Jouw berekening: ' + n + ' schermen = ' + money(total, cur) + ' per maand' + (isComp ? ' bij ' + (termLabels[t] || '') : '') + '.';
          }
          all('[data-es-cta]', function (b) {
            var base = b.getAttribute('data-es-cta-base') || b.textContent;
            b.textContent = n > 1 ? (/^Kies /.test(base) ? base.replace(/^Kies /, 'Kies ' + n + ' × ') : base + ' (' + n + ' schermen)') : base;
          });

          /* Formulier bijwerken */
          if (form) {
            var v = pickVariant(i);
            if (v) form.querySelector('input[name="id"]').value = v.id;
            form.querySelector('input[name="quantity"]').value = n;
            var pp = form.querySelector('[data-es-prop="prijs"]');
            if (pp) pp.value = money(unit, cur);
            var pl = form.querySelector('[data-es-prop="looptijd"]');
            if (pl) pl.value = termLabels[t] || '';
          }
        }

        all('[data-es-step]', function (b) {
          b.addEventListener('click', function () {
            input.value = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-es-step'), 10);
            update();
          });
        });
        input.addEventListener('input', update);
        input.addEventListener('change', update);
        all('[data-es-term-input]', function (r) {
          r.addEventListener('change', function () { if (r.checked) { term = parseInt(r.value, 10) || 0; update(); } });
        });

        /* Pop-up openen en sluiten */
        if (modal) {
          all('[data-es-open]', function (b) {
            b.addEventListener('click', function () {
              if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
              document.documentElement.classList.add('es-modal-open');
              setTimeout(function () { input.focus(); input.select(); }, 50);
            });
          });
          all('[data-es-close]', function (b) {
            b.addEventListener('click', function () { if (modal.close) modal.close(); else modal.removeAttribute('open'); });
          });
          modal.addEventListener('click', function (e) { if (e.target === modal && modal.close) modal.close(); });
          modal.addEventListener('close', function () { document.documentElement.classList.remove('es-modal-open'); });
        }

        /* Klik in een kaart = die kaart geselecteerd */
        function select() {
          sec.querySelectorAll('[data-es-plan]').forEach(function (p) {
            var on = p === panel;
            p.classList.toggle('is-selected', on);
            p.querySelectorAll('.es-pcard__btn').forEach(function (b) {
              b.classList.toggle('es-btn--primary', on);
              b.classList.toggle('es-btn--outline', !on);
            });
          });
        }
        panel.addEventListener('click', select);
        panel.addEventListener('focusin', select);

        update();
      });
    });
  }

  /* ---------- Actieve link in subnavigatie ---------- */
  function initSubnav(root) {
    root.querySelectorAll('.es-subnav nav').forEach(function (nav) {
      if (nav._es || !io) return;
      nav._es = true;
      var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id); });
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      links.forEach(function (a) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (t) obs.observe(t);
      });
    });
  }

  function init(root) {
    root = root || document;
    initSlides(root); initReveal(root); initPricing(root); initSubnav(root);
  }

  window.ErmecoSignage = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
